import { EVENTS } from "../constants/events.constants";
class OrganizationManager {
    organization;
    ref;
    constructor(organization) {
        this.organization = organization || null;
    }
    setOrganization(value) {
        this.organization = JSON.parse(JSON.stringify(value));
        if (this.ref) {
            this.ref.value = JSON.parse(JSON.stringify(value));
        }
        window.dispatchEvent(new CustomEvent(EVENTS.setOrganization, {
            detail: { organization: JSON.parse(JSON.stringify(value)) },
        }));
    }
    setRef(ref) {
        ref.value = JSON.parse(JSON.stringify(this.organization));
        this.ref = ref;
    }
}
export function CreateOrganizationManager() {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    return new OrganizationManager();
}
